module.exports = __webpack_public_path__ + "img/RepushReport.42adba96.svg";